export var InteractionTypes;
(function (InteractionTypes) {
    InteractionTypes["PURCHASE_OFF"] = "purchaseOff";
    InteractionTypes["PURCHASE_ON"] = "purchaseOn";
    InteractionTypes["CONTACT"] = "contact";
    InteractionTypes["RESCHEDULE"] = "reschedule";
})(InteractionTypes || (InteractionTypes = {}));
